// Copyright (c) 2026 Celadonsoft
// All rights reserved.

export default {
  methods: {
    bannerText(content) {
      const text = this.getTranslatedContent('banner', content);
      const $body = new DOMParser().parseFromString(text, 'text/html').querySelector('body');
      // TODO: fix floara
      if ($body.lastChild && $body.lastChild.innerText === 'Powered by Froala Editor') {
        $body.removeChild($body.lastChild);
      }

      this.marginSanitize($body);
      this.stripInlineFontFamily($body);
      return text ? $body.innerHTML : '';
    },

    bannerPageText(content) {
      const text = this.getTranslatedContent('description_banner_title', content);
      const $body = new DOMParser().parseFromString(text, 'text/html').querySelector('body');

      this.marginSanitize($body);
      this.stripInlineFontFamily($body);
      return text ? $body.innerHTML : '';
    },

    itemContent(key, content) {
      return this.getTranslatedContent(key, content);
    },

    description(content) {
      const text =
        this.getTranslatedContent('description_banner_title', content) ||
        this.getTranslatedContent('text', content);
      const $body = new DOMParser().parseFromString(text, 'text/html').querySelector('body');
      // TODO: fix floara
      if ($body.lastChild && $body.lastChild.innerText === 'Powered by Froala Editor') {
        $body.removeChild($body.lastChild);
      }

      this.marginSanitize($body);
      this.stripInlineFontFamily($body);
      return text ? $body.innerHTML : '';
    },

    textSanitize(content) {
      const $body = new DOMParser().parseFromString(content, 'text/html').querySelector('body');

      this.marginSanitize($body);
      this.stripInlineFontFamily($body);
      return $body.innerHTML;
    },

    // Quill writes an empty line as <p><br></p>; only that shape gets the fixed spacer.
    // A paragraph with any text in it must keep a height that follows its content, or the
    // text overflows onto the next paragraph (firstElementChild used to skip over the text).
    marginSanitize($node) {
      for (let i = 0; i < $node.childNodes.length; i++) {
        const $child = $node.childNodes[i];
        if (
          $child.firstChild &&
          $child.firstChild.nodeName === 'BR' &&
          !$child.textContent.trim()
        ) {
          $child.style.height = '15px';
        }
      }
    },

    // The Quill editor in the CMS sometimes writes style="font-family: Open Sans;"
    // straight into the content. That inline style outranks the site's SCSS, which
    // always sets a `, sans-serif` fallback - so the browser is forced to wait for
    // the webfont file with nothing to fall back to, painting the browser's default
    // serif until it arrives. Stripping just this one property (not the whole
    // style attribute, so alignment etc. from Quill survives) lets the same
    // SCSS fallback these blocks already have everywhere else take over.
    stripInlineFontFamily($node) {
      for (let i = 0; i < $node.childNodes.length; i++) {
        const $child = $node.childNodes[i];
        this.stripInlineFontFamily($child);
        if (!$child.style) continue;
        $child.style.removeProperty('font-family');
        if ($child.getAttribute('style') === '') {
          $child.removeAttribute('style');
        }
        // Quill also writes font choice as a class (ql-font-open, ql-font-arial,
        // etc). src/design/_sizes.scss defines .ql-font-open with NO sans-serif
        // fallback at all, so if content ever carries it, the browser has
        // nothing to paint until the webfont arrives.
        if ($child.classList) {
          Array.from($child.classList)
            .filter((c) => c.startsWith('ql-font-'))
            .forEach((c) => $child.classList.remove(c));
        }
      }
    },

    sanitize($node) {
      for (let i = 0; i < $node.childNodes.length; i++) {
        const $child = $node.childNodes[i];
        this.sanitize($child);
        if ($child.removeAttribute) $child.removeAttribute('style');
      }
    },
  },
};
